import { Injectable, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { overlayConfigFactory } from 'ngx-modialog';
import { Router } from '@angular/router';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AlertService implements OnChanges, OnInit, OnDestroy {

	// variables
	protected _openedModal: any = null;
	private _titleTanslated_sub: BehaviorSubject<string> = new BehaviorSubject("");
	private _msgTanslated_sub: BehaviorSubject<string> = new BehaviorSubject("");

	/* --------------------- */

	public constructor(
		protected _modal: Modal,
		protected _router: Router) {



	}

	/* --------------------- */

	public ngOnChanges() { }

	public ngOnInit() { }

	public ngOnDestroy() {



		this._unsubscribeAll();

	}

	/* --------------------- */

	/**
     * Show GENERIC _modal ALERT
	 *
     * @param title
     * @param message
     * @param type
     */
	public showModalAlert(title: string, message: string, type: string = 'default', redirect: string = '', okBtnLabel = "X",topDialog: string = '' , highlighted: boolean = false) {

		if (!this._openedModal) {


			// build header
			var titleHTML;
	 

			/*
			if (type == 'default') {

				titleHTML = "<h2 class='text-center _modal-title text-center'>" + title + '</h2>';

			} else {
				//<img  class='d-table-cell align-middle' src='./assets/img/icon_alert_" + type + ".png' />
				titleHTML = "<div class='text-center _modal-title-img d-table'><h2 class='_modal-title pl-3 d-table-cell align-middle'>" + title + '</h2></div>';

			}
			*/

			// create and open _modal
			var dialogRef =

				this._modal.alert()
					.size('lg')
					.isBlocking(true)
					.showClose(false)
					.keyboard(27)
					.dialogClass('modal-dialog modal-generic modal-custom ' + type +' '+topDialog)
					.headerClass('modal-header text-center text-danger pr-5')
					.titleHtml(title)
					.body(message)
					.bodyClass('modal-body')
					.footerClass('modal-footer')
					.okBtn(okBtnLabel)
					.okBtnClass('btn btn-danger')
					.open();

			dialogRef.result.then(

				(result) => {

					dialogRef.onDestroy.subscribe(

						res => {

							this._openedModal = null;
							document.body.classList.remove('modal-open');

							if (redirect) {

								this._router.navigateByUrl(redirect);

							}

						},

						err => { document.body.classList.remove('modal-open');}

					);
				},

				() => { }

			);

			return dialogRef;

		}

	}

	/**
     * Show ERROR _modal ALERT
     *
     * @param message
     */
	public showModalAlertError(title, message: string, redirect?: string, okBtnLabel?: string, topDialog?: string) {

		return this.showModalAlert(title, message, 'error', redirect, okBtnLabel,topDialog);

	}

	/**
	 * Show INFO _modal ALERT
	 *
	 * @param message
	 */
	public showModalAlertInfo(title: string, message: string, redirect?: string, okBtnLabel?: string, topDialog?: string) {

		return this.showModalAlert(title, message, 'info', redirect, okBtnLabel,topDialog);

	}

	/**
	 * Show SUCCESS _modal ALERT
	 *
	 * @param message
	 */
	public showModalAlertSuccess(title: string, message: string, redirect?: string, okBtnLabel?: string, topDialog?: string) {

		return this.showModalAlert(title, message, 'success', redirect, okBtnLabel,topDialog);

	}

	/**
	 * Show WARNING _modal ALERT
	 *
	 * @param message
	 */
	public showModalAlertWarning(title: string, message: string, redirect?: string, okBtnLabel?: string, topDialog?: string) {
		okBtnLabel = 'X'
		return this.showModalAlert(title, message, 'warning', redirect, okBtnLabel,topDialog);

	}

	/* --------------------- */

	/**
	 * Show _modal CONFIRM
	 *
	 * @param title
	 * @param message
	 */
	public showModalConfirm(title: string, message: string, OkBtnLabel = "OK", CancelBtnLabel = "X",topDialog?: string, highlighted: boolean = false) {

		return this._modal.confirm()
			.size('lg')
			.isBlocking(true)
			.showClose(false)
			.keyboard(27)
			.dialogClass('modal-dialog modal-generic confirm '+topDialog)
			.headerClass('modal-header text-center text-danger pr-5')
			.titleHtml(title)
			.body(message)
			.bodyClass('modal-body')
			.footerClass('modal-footer')
			.okBtn(OkBtnLabel)
			.okBtnClass('btn btn-danger ok')
			.cancelBtn(CancelBtnLabel)
			.cancelBtnClass('btn btn-danger cancel')
			.open();

	}

	/* --------------------- */

	/**
	 * Show _modal PROMPT
	 *
	 * @param title
	 * @param placeholder
	 * @param message
	 */
	public showModalPrompt(title: string, placeholder: string, message: string, okBtnLabel = "OK", CancelBtnLabel = "Cancel") {

		var dialogRef = this._modal.prompt()
			.size('lg')
			.isBlocking(true)
			.showClose(false)
			.keyboard(27)
			.dialogClass('modal-dialog')
			.headerClass('modal-header text-center text-danger pr-5')
			.title(title)
			.placeholder(placeholder)
			.body(message)
			.bodyClass('modal-body')
			.footerClass('modal-footer')
			.okBtn(okBtnLabel)
			.okBtnClass('btn btn-danger')
			.cancelBtn(CancelBtnLabel)
			.cancelBtnClass('btn btn-danger')
			.open();

		dialogRef.result.then(

			(result) => {

				dialogRef.onDestroy.subscribe(

					res => {

						this._openedModal = null;

					},

					err => { }

				);

			},

			() => { }

		);

	}

	/* --------------------- */

	/**
     * Show generic MODAL with CUSTOM EXTERNAL TEMPLATE
     *
     * @param template
     */
	public showModalWithTemplate(template, dialogClass) {

		return this._modal.open(template, overlayConfigFactory({

			keyboard: 1,
			isBlocking: true,
			dialogClass: dialogClass

		}, BSModalContext));

	}

	/* --------------------- */

    /**
     * Manage error alert by object
     *
     * @param error
     */
	public manageError(error: any) {

		if (error) {

			if (error.alert && error.redirect) {

				this._openedModal = this.showModalAlertError(error.alert, error.redirect);

			} else if (error.alert) {

				this._openedModal = this.showModalAlertError(error.alert, '');

			} else if (error.redirect) {

				this.manageRedirect(error.redirect);

			}

		}

	}

	/**
	 * Manage success alert by object
	 *
	 * @param message
	 */
	public manageSuccess(success: any) {

		this._openedModal = this.showModalAlertSuccess(success.alert, '');

		if (success.redirect) {

			this.manageRedirect(success.redirect);

		}

	}

	/**
	 * Redirect to specific URL
	 *
	 * @param redirect
	 */
	public manageRedirect(redirect: any) {

		this._router.navigateByUrl(redirect);

	}

	/* --------------------- */

	protected _unsubscribeAll() {

		if (this._titleTanslated_sub) { this._titleTanslated_sub.unsubscribe(); }
		if (this._msgTanslated_sub) { this._msgTanslated_sub.unsubscribe(); }

	}

}



// WEBPACK FOOTER //
// ./src/app/theme/services/alert.service.ts